import { defineComponent, createBlock, openBlock, unref, withCtx, createVNode, normalizeProps, guardReactiveProps, renderSlot } from "vue";
import _sfc_main$2 from "../../button/Button.js";
import "../../button/variants.js";
import { _ as _sfc_main$1 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/AlertDialog/AlertDialogAction.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertDialogAction",
  props: {
    onClick: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {},
    buttonType: {},
    size: {},
    loading: { type: Boolean },
    disabled: { type: Boolean },
    buttonVariant: {},
    danger: { type: Boolean },
    shape: {},
    href: {},
    target: {},
    variant: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), {
      class: "contents",
      as: "div",
      "as-child": _ctx.asChild
    }, {
      default: withCtx(() => [
        createVNode(unref(_sfc_main$2), normalizeProps(guardReactiveProps(props)), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["as-child"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AlertDialogAction.js.map
